module.exports = new Promise((resolve, reject) => {
            const base = (window?.configs?.MICROFRONTENDS_URL || '').replace(/\/$/, '');
            const build = '';
            const urlPath = build ? '/email-template-builder/' + build : '/email-template-builder';
            const remoteUrl = base + urlPath + '/remoteEntry.js';

            if (window.email_template_builder) {
              resolve(window.email_template_builder);
              return;
            }

            const script = document.createElement('script');
            script.src = remoteUrl;
            script.onload = () => {
              const proxy = {
                get: (request) => window.email_template_builder.get(request),
                init: (arg) => {
                  try { return window.email_template_builder.init(arg); }
                  catch (e) { console.log('email_template_builder already initialized'); }
                }
              };
              resolve(proxy);
            };
            script.onerror = () => reject(new Error('Failed to load email_template_builder: ' + remoteUrl));
            document.head.appendChild(script);
          });